var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDressingSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 112 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_07",
    "data-name": 7,
    transform: "translate(-499 -56.076)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_53",
    transform: "translate(499.65 76.872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10583",
    "data-name": "Group 10583",
    transform: "translate(27.792 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12675",
    "data-name": "Path 12675",
    d: "M30.588,23.166l7.261-7.261a5.034,5.034,0,0,1,1.9-1.183L47.695,12c-1.375,2.5-.248,5.583.358,6.931a.735.735,0,0,0,.99.358l2.75-1.238,1.705,2.31V55.867A43.129,43.129,0,0,1,40.407,52.4a1.888,1.888,0,0,1-1.073-1.76l.578-20.9a.418.418,0,0,0-.385-.413.518.518,0,0,0-.22.055l-2.365,1.6a.907.907,0,0,1-1.238-.193l-5.2-6.381a.958.958,0,0,1,.083-1.238Z",
    transform: "translate(-29.623 -8.7)",
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12676",
    "data-name": "Path 12676",
    d: "M101.839,11.136l1.705,2.31,1.705-2.31c4.95-6.491.935-8.636.935-8.636h-5.253S96.916,4.673,101.839,11.136Z",
    transform: "translate(-79.697 -1.812)",
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12677",
    "data-name": "Path 12677",
    d: "M134.2,96.8h24.7v3.08H134.2Z",
    transform: "translate(-104.935 -70.177)",
    fill: "#989fd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12678",
    "data-name": "Path 12678",
    d: "M187.5,242.3h10.506v3.08H187.5Z",
    transform: "translate(-143.576 -175.661)",
    fill: "#989fd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12679",
    "data-name": "Path 12679",
    d: "M132.5,242.3h10.506v3.08H132.5Z",
    transform: "translate(-103.702 -175.661)",
    fill: "#989fd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12680",
    "data-name": "Path 12680",
    d: "M191.064,145.009l.385-36.909H179.1v11.414l2.833,25.5Z",
    transform: "translate(-137.486 -78.37)",
    fill: "#6a75b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12681",
    "data-name": "Path 12681",
    d: "M134.585,145.009h9.1l2.86-25.5V108.1H134.2Z",
    transform: "translate(-104.935 -78.37)",
    fill: "#6a75b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12682",
    "data-name": "Path 12682",
    d: "M119.918,38.43V35.322h8.361l-.165-5.583a.418.418,0,0,1,.385-.413.518.518,0,0,1,.22.055l2.365,1.6a.907.907,0,0,0,1.238-.193l5.143-6.381a.927.927,0,0,0-.055-1.238l-7.261-7.261a5.034,5.034,0,0,0-1.9-1.183L120.3,12c1.375,2.5.248,5.583-.358,6.931a.735.735,0,0,1-.99.358l-2.75-1.238-1.705,2.31V55.867a43,43,0,0,0,5.583-.935Z",
    transform: "translate(-90.653 -8.7)",
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10582",
    "data-name": "Group 10582",
    transform: "translate(0.672 0.688)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12683",
    "data-name": "Path 12683",
    d: "M121.635,2.5s4.015,2.173-.935,8.636l2.75,1.238a.758.758,0,0,0,.99-.358c.853-1.87,2.75-7.233-2.805-9.516Z",
    transform: "translate(-95.819 -2.5)",
    fill: "#fccc90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12684",
    "data-name": "Path 12684",
    d: "M94.881,2.5s-4.015,2.173.935,8.636l-2.75,1.238a.758.758,0,0,1-.99-.358C91.2,10.146,89.3,4.783,94.881,2.5Z",
    transform: "translate(-74.319 -2.5)",
    fill: "#fccc90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12685",
    "data-name": "Path 12685",
    d: "M164.5,23.663a5.377,5.377,0,0,0-1.375-.963c-.743,2.53-2.145,8.553-.413,14.439a.411.411,0,0,1,.357.028l2.365,1.6a.907.907,0,0,0,1.238-.193l5.143-6.408a.927.927,0,0,0-.055-1.238Z",
    transform: "translate(-125.676 -17.144)",
    fill: "#fccc90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12686",
    "data-name": "Path 12686",
    d: "M37.788,23.663a5.377,5.377,0,0,1,1.375-.963c.743,2.53,2.145,8.553.413,14.439a.411.411,0,0,0-.358.028l-2.365,1.6a.907.907,0,0,1-1.238-.193l-5.171-6.408a.927.927,0,0,1,.055-1.238Z",
    transform: "translate(-30.234 -17.144)",
    fill: "#fccc90"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12687",
    "data-name": "Path 12687",
    d: "M172.168,96.8a1.554,1.554,0,0,0-.027,3.108h13.146V96.8Z",
    transform: "translate(-131.324 -70.177)",
    fill: "#989fd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12688",
    "data-name": "Path 12688",
    d: "M175.413,98.44a1.538,1.538,0,0,0-1.54-1.54h-1.705a1.554,1.554,0,0,0-.027,3.108h1.733A1.579,1.579,0,0,0,175.413,98.44Z",
    transform: "translate(-131.324 -70.25)",
    fill: "#29589f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12689",
    "data-name": "Path 12689",
    d: "M211.7,111.923a3.88,3.88,0,0,0,3.328,3.85l.083-7.673H211.7Z",
    transform: "translate(-161.12 -78.37)",
    fill: "#989fd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12690",
    "data-name": "Path 12690",
    d: "M137.51,111.923a3.88,3.88,0,0,1-3.328,3.85L134.1,108.1h3.41Z",
    transform: "translate(-104.862 -78.37)",
    fill: "#989fd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12691",
    "data-name": "Path 12691",
    d: "M168.4,115.966l2.943,2.283V108.1H168.4Z",
    transform: "translate(-129.729 -78.37)",
    fill: "#989fd7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_376",
    "data-name": "Ellipse 376",
    cx: 0.853,
    cy: 0.853,
    r: 0.853,
    transform: "translate(4.98 28.96)",
    fill: "#f5c84c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_377",
    "data-name": "Ellipse 377",
    cx: 0.853,
    cy: 0.853,
    r: 0.853,
    transform: "translate(23.957 56.738)",
    fill: "#87d147"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_378",
    "data-name": "Ellipse 378",
    cx: 0.853,
    cy: 0.853,
    r: 0.853,
    transform: "translate(52.835 14.934)",
    fill: "#fc657e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12692",
    "data-name": "Path 12692",
    d: "M203.9,23.993a2.929,2.929,0,0,1-2.365-2.338.059.059,0,0,0-.055-.055c-.027,0-.028.028-.055.055a3,3,0,0,1-2.365,2.338.059.059,0,0,0-.055.055c0,.028.027.028.055.055a2.929,2.929,0,0,1,2.365,2.338.059.059,0,0,0,.055.055c.027,0,.027-.028.055-.055A3,3,0,0,1,203.9,24.1a.055.055,0,0,0,0-.11Z",
    transform: "translate(-151.913 -15.659)",
    fill: "#f5c84c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12693",
    "data-name": "Path 12693",
    d: "M89.548,182.375H88.97V181.8a.8.8,0,0,0-1.6,0v.578H86.8a.8.8,0,0,0,0,1.6h.578v.578a.8.8,0,0,0,1.6,0v-.578h.578a.8.8,0,0,0,0-1.6Z",
    transform: "translate(-69.991 -131.22)",
    fill: "#70d6f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12694",
    "data-name": "Path 12694",
    d: "M71.028,66.639v3.08a.681.681,0,0,0,.688.688H82.222a.681.681,0,0,0,.688-.688v-3.08a.681.681,0,0,0-.688-.688h-.165l.3-28.548c.193-18.069-.027,2.008.083-10.781a.681.681,0,0,0-.688-.688H66.078l-.11-4.345,1.9,1.265a1.592,1.592,0,0,0,2.145-.33l5.116-6.408a1.6,1.6,0,0,0-.11-2.145L67.755,6.711A6.033,6.033,0,0,0,65.61,5.363l-7.728-2.64A6.767,6.767,0,0,0,54.527.055.8.8,0,0,0,54.279,0H49.026a1.21,1.21,0,0,0-.275.055A6.793,6.793,0,0,0,45.4,2.723l-7.728,2.64a5.674,5.674,0,0,0-2.145,1.348l-7.261,7.261a1.6,1.6,0,0,0-.11,2.145l5.116,6.408a1.592,1.592,0,0,0,2.145.33l1.9-1.265-.55,20.325a2.587,2.587,0,0,0,1.458,2.393,42.434,42.434,0,0,0,13.339,3.52h.11a41.218,41.218,0,0,0,4.84-.77L56.7,65.9h-.165a.681.681,0,0,0-.688.688v3.08a.681.681,0,0,0,.688.688H67.04a.681.681,0,0,0,.688-.688v-3.08a.691.691,0,0,0-.44-.633L69.378,47.3l2.09,18.647a.8.8,0,0,0-.44.688Zm10.506,2.393H72.4V67.327h9.131ZM79.059,30.418h2.008L81.012,36.5a3.211,3.211,0,0,1-1.953-2.943Zm2.008-1.375H72.376a2.285,2.285,0,0,0,0-1.705h8.691ZM70.341,27.31a.866.866,0,1,1,.027,1.733H68.635a.866.866,0,0,1,0-1.733ZM68.718,38.476l-1.568-1.21V30.418h1.568ZM57.744,30.418h2.008v3.135A3.182,3.182,0,0,1,57.8,36.5Zm0-1.375V27.338h8.828a2.285,2.285,0,0,0,0,1.705ZM74.053,15.264l-5.116,6.408a.254.254,0,0,1-.33.055l-2.365-1.6a1.2,1.2,0,0,0-.193-.11h-.028a26.124,26.124,0,0,1,.3-12.734,3.166,3.166,0,0,1,.468.385l7.261,7.288a.216.216,0,0,1,0,.3Zm-17.6-5.336a.053.053,0,0,1-.083.028l-1.98-.908c1.21-1.705,2.338-3.905,2.063-6C57.937,4.95,57.469,7.728,56.452,9.928ZM48.228,3a2.8,2.8,0,0,1,.99-1.623h4.84a2.761,2.761,0,0,1,1.045,1.9c.3,2.833-2.778,6.133-3.465,7.206C50.924,9.351,47.651,5.858,48.228,3Zm.66,6.051-1.98.908a.1.1,0,0,1-.083-.028c-1.018-2.2-1.513-4.978,0-6.876C46.551,5.143,47.706,7.343,48.889,9.048ZM34.67,21.727a.254.254,0,0,1-.33-.055l-5.116-6.408a.227.227,0,0,1,.028-.33L36.485,7.7a3.166,3.166,0,0,1,.468-.385,26.124,26.124,0,0,1,.3,12.734.823.823,0,0,0-.22.11Zm3.493,20.242.578-20.9a1.178,1.178,0,0,0-.165-.605,27.555,27.555,0,0,0-.358-13.834L44.708,4.4a9.583,9.583,0,0,0,.908,6.078,1.464,1.464,0,0,0,1.9.715l2.228-1.018,1.238,1.678V46.4A42.029,42.029,0,0,1,38.85,43.069,1.136,1.136,0,0,1,38.162,41.969ZM52.326,46.4V11.881L53.564,10.2l2.228,1.018a1.44,1.44,0,0,0,1.9-.715c.083-.165.165-.358.22-.5A9.412,9.412,0,0,0,58.6,4.4l6.491,2.228a27.555,27.555,0,0,0-.358,13.834,1.109,1.109,0,0,0-.165.605l.138,4.868H57.057a.681.681,0,0,0-.688.688L56.452,37.4l.083,8.278a36.855,36.855,0,0,1-4.208.715Zm5.5-8.471a4.6,4.6,0,0,0,3.3-4.4V30.391h4.648v7.178a.718.718,0,0,0,.275.55l2.668,2.063v.908L65.94,65.924H58.129Zm8.581,31.106H57.277V67.327h9.131Zm3.685-38.614h7.591v3.135a4.6,4.6,0,0,0,3.3,4.4l-.3,28H72.871L70.093,41.117Z",
    transform: "translate(-27.792 0)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDressingSmall);
export default __webpack_public_path__ + "static/media/dressing_small.99d9ecda386f1092150ade7f37189b43.svg";
export { ForwardRef as ReactComponent };